import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const { toast } = useToast();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: "Message Sent!",
      description: "Thank you for contacting us. We'll get back to you soon.",
    });
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div>
      {/* Page Header */}
      <div className="bg-gray-800 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center">Contact Us</h1>
        </div>
      </div>

      {/* Contact Info Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-16">
            <div className="text-center p-6 bg-gray-50 hover:bg-yellow-50 transition-colors">
              <MapPin className="mx-auto mb-4 text-yellow-500" size={48} />
              <h3 className="font-bold text-gray-800 mb-2">Visit Us</h3>
              <p className="text-gray-600 text-sm">No-63/1 & 63/2, Shed No-7.Karihobanahalli. Near BBMP office. Thigalarapaya. Bangalore-560073</p>
            </div>
            <div className="text-center p-6 bg-gray-50 hover:bg-yellow-50 transition-colors">
              <Phone className="mx-auto mb-4 text-yellow-500" size={48} />
              <h3 className="font-bold text-gray-800 mb-2">Call Us</h3>
              <p className="text-gray-600 text-sm">(+91) 91139 97209</p>
            </div>
            <div className="text-center p-6 bg-gray-50 hover:bg-yellow-50 transition-colors">
              <Mail className="mx-auto mb-4 text-yellow-500" size={48} />
              <h3 className="font-bold text-gray-800 mb-2">Email Us</h3>
              <p className="text-gray-600 text-sm">contactaranvic@gmail.com</p>
            </div>
            <div className="text-center p-6 bg-gray-50 hover:bg-yellow-50 transition-colors">
              <Clock className="mx-auto mb-4 text-yellow-500" size={48} />
              <h3 className="font-bold text-gray-800 mb-2">Working Hours</h3>
              <p className="text-gray-600 text-sm">Mon-Fri: 10:00-16:00</p>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Get In Touch</h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <Input
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <Input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <Input
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <Textarea
                    name="message"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={6}
                    required
                  />
                </div>
                <Button type="submit" className="w-full bg-yellow-500 hover:bg-yellow-600 text-white py-6 text-lg">
                  Send Message
                </Button>
              </form>
            </div>

            {/* Map or Additional Info */}
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Location</h2>
              <div className="bg-gray-200 h-96 flex items-center justify-center">
                <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3887.230679214762!2d77.48448557507729!3d13.020976987298962!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDAxJzE1LjUiTiA3N8KwMjknMTMuNCJF!5e0!3m2!1sen!2sin!4v1764933629333!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Our Location"
              />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;